import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { useQuery } from '@apollo/client/react'

import { NotFound } from 'js/core/NotFound'
import AddEditForm from 'js/magazine-issue/AddEditArticle/AddEditForm'
import { GET_ARTICLE_EDIT } from 'js/magazine-issue/AddEditArticle/Edit/Edit.queries'

const Edit = () => {
    const { t } = useTranslation()
    const { containerGuid, guid } = useParams()

    const { loading, data } = useQuery(GET_ARTICLE_EDIT, {
        variables: {
            containerGuid,
            guid,
        },
    })

    if (loading) {
        return null
    }
    if (!data || !data.entity) {
        return <NotFound />
    }

    const { site, viewer, entity, container } = data

    return (
        <AddEditForm
            title={t('entity-magazine.edit-article')}
            site={site}
            viewer={viewer}
            container={container}
            entity={entity}
        />
    )
}

export default Edit
